import { render, staticRenderFns } from "./TestEditor.vue?vue&type=template&id=1a56078c&scoped=true"
import script from "./TestEditor.vue?vue&type=script&lang=js"
export * from "./TestEditor.vue?vue&type=script&lang=js"
import style0 from "./TestEditor.vue?vue&type=style&index=0&id=1a56078c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a56078c",
  null
  
)

export default component.exports